export enum Basename {
    ENGB = '/en-gb',
    ENUS = '/',
}
